import React from "react";
import CtaSection2 from "./../components/CtaSection2";
import FaqSection from "./../components/FaqSection";
import { useRouter } from "./../util/router.js";

function CrowdSourcePage(props) {
  const router = useRouter();

  return (
    <>
      <CtaSection2
        color="white"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Want to get involved and help crowdsource?"
        subtitle="We are looking for volunteer contributors to help us crowdsource news, testing centers and other covid related information in your respective community. We provide the distribbution system, but we need you to help provide the reliable information!"
        buttonText="SIGN UP"
        buttonOnClick={() => {
          // Navigate to pricing page
          //router.push('/pricing');
          window.location.replace(
            "https://covidcrowdsource.typeform.com/to/c1ev2R"
          );

          global.window.location.href =
            "https://covidcrowdsource.typeform.com/to/c1ev2R";
        }}
      ></CtaSection2>
      <FaqSection
        color="white"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Frequently Asked Questions"
        subtitle=""
      ></FaqSection>
    </>
  );
}

export default CrowdSourcePage;
